const request = {}

request.createRequest = function (params) {
  return { completeDate: params.date }
}
export default { request }
